import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: any;
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: any;
  /** A field whose value is a Currency: https://en.wikipedia.org/wiki/ISO_4217. */
  Currency: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  Duration: any;
  /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
  EmailAddress: any;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  GUID: any;
  /** A field whose value is a CSS HSL color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSL: any;
  /** A field whose value is a CSS HSLA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSLA: any;
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: any;
  /** A field whose value is a hexadecimal: https://en.wikipedia.org/wiki/Hexadecimal. */
  Hexadecimal: any;
  /** A field whose value is an International Bank Account Number (IBAN): https://en.wikipedia.org/wiki/International_Bank_Account_Number. */
  IBAN: any;
  /** A field whose value is a IPv4 address: https://en.wikipedia.org/wiki/IPv4. */
  IPv4: any;
  /** A field whose value is a IPv6 address: https://en.wikipedia.org/wiki/IPv6. */
  IPv6: any;
  /** A field whose value is a ISBN-10 or ISBN-13 number: https://en.wikipedia.org/wiki/International_Standard_Book_Number. */
  ISBN: any;
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  ISO8601Duration: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  LocalDate: any;
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`.  This scalar is very similar to the `LocalTime`, with the only difference being that `LocalEndTime` also allows `24:00` as a valid value to indicate midnight of the following day.  This is useful when using the scalar to represent the exclusive upper bound of a time block. */
  LocalEndTime: any;
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`. */
  LocalTime: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: any;
  /** A field whose value is a IEEE 802 48-bit MAC address: https://en.wikipedia.org/wiki/MAC_address. */
  MAC: any;
  /** Floats that will have a value less than 0. */
  NegativeFloat: any;
  /** Integers that will have a value less than 0. */
  NegativeInt: any;
  /** A string that cannot be passed as an empty value */
  NonEmptyString: any;
  /** Floats that will have a value of 0 or more. */
  NonNegativeFloat: any;
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: any;
  /** Floats that will have a value of 0 or less. */
  NonPositiveFloat: any;
  /** Integers that will have a value of 0 or less. */
  NonPositiveInt: any;
  /** A field whose value conforms with the standard mongodb object ID as described here: https://docs.mongodb.com/manual/reference/method/ObjectId/#ObjectId. Example: 5e5677d71bdc2ae76344968c */
  ObjectID: any;
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: any;
  /** A field whose value is a valid TCP port within the range of 0 to 65535: https://en.wikipedia.org/wiki/Transmission_Control_Protocol#TCP_ports */
  Port: any;
  /** Floats that will have a value greater than 0. */
  PositiveFloat: any;
  /** Integers that will have a value greater than 0. */
  PositiveInt: any;
  /** A field whose value conforms to the standard postal code formats for United States, United Kingdom, Germany, Canada, France, Italy, Australia, Netherlands, Spain, Denmark, Sweden, Belgium, India, Austria, Portugal, Switzerland or Luxembourg. */
  PostalCode: any;
  /** A field whose value is a CSS RGB color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGB: any;
  /** A field whose value is a CSS RGBA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGBA: any;
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: any;
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: any;
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: any;
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: any;
  /** A currency string, such as $21.25 */
  USCurrency: any;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: any;
  /** Floats that will have a value of 0 or more. */
  UnsignedFloat: any;
  /** Integers that will have a value of 0 or more. */
  UnsignedInt: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
  /** A field whose value is a UTC Offset: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
  UtcOffset: any;
  /** Represents NULL values */
  Void: any;
};

export type Applicant = {
  __typename?: 'Applicant';
  id: Scalars['ID'];
};

export type ApplicantPayload = {
  __typename?: 'ApplicantPayload';
  applicant: Applicant;
};

export type ApplicantWordbook = {
  __typename?: 'ApplicantWordbook';
  color: Scalars['String'];
  created_at: Scalars['Date'];
  dDate?: Maybe<Scalars['DateTime']>;
  d_time: Scalars['DateTime'];
  daily_word_amount: Scalars['Int'];
  deleted_at?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  detail: Scalars['String'];
  friday: Scalars['Boolean'];
  group?: Maybe<Group>;
  group_order: Scalars['Int'];
  id: Scalars['ID'];
  is_hide: Scalars['Boolean'];
  is_hint: Scalars['Boolean'];
  is_ours: Scalars['Boolean'];
  is_receiver: Scalars['Int'];
  is_test: Scalars['Int'];
  kakao_notice: Scalars['Int'];
  manager_id: Scalars['Int'];
  manager_kakao_id?: Maybe<Scalars['String']>;
  manager_kakao_link?: Maybe<Scalars['String']>;
  manager_rec_id?: Maybe<Scalars['String']>;
  monday: Scalars['Boolean'];
  organization_id: Scalars['Int'];
  rec_id?: Maybe<Scalars['String']>;
  saturday: Scalars['Boolean'];
  step: Scalars['Int'];
  subtitle: Scalars['String'];
  sunday: Scalars['Boolean'];
  thursday: Scalars['Boolean'];
  title: Scalars['String'];
  total_word_amount: Scalars['Int'];
  tuseday: Scalars['Boolean'];
  type?: Maybe<Scalars['Int']>;
  updated_at: Scalars['Date'];
  wednesday: Scalars['Boolean'];
  wordbook_id: Scalars['Int'];
};

export type ApplicantWordbookInput = {
  applicantWordbookId?: Maybe<Scalars['ID']>;
};

export enum ApplicantWordbooksFilterPreset {
  APPLICANT_SIGNUP = 'APPLICANT_SIGNUP',
  ONBOARDING_SIGNUP = 'ONBOARDING_SIGNUP',
}

export type ApplyApplicantInput = {
  applicantWordbookId: Scalars['ID'];
  preferSelfStudy?: Maybe<Scalars['Boolean']>;
  site?: Maybe<Scalars['Int']>;
  userId: Scalars['ID'];
};

export type ApplyWordbookUserInput = {
  applicantWordbookId: Scalars['ID'];
  phoneNumber: Scalars['String'];
  site: Scalars['Int'];
  wordbookName: Scalars['String'];
};

export type ApplyWordbookUserPayload = {
  __typename?: 'ApplyWordbookUserPayload';
  applicantId: Scalars['ID'];
};

export enum AuthenticationType {
  FIND_PASSWORD = 'FIND_PASSWORD',
  SINGUP = 'SINGUP',
}

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export enum ErrorCode {
  ALREADY_APPLIED_USER = 'ALREADY_APPLIED_USER',
  ALREADY_HAVE_ROLE = 'ALREADY_HAVE_ROLE',
  ALREADY_SIGNUP_EMAIL = 'ALREADY_SIGNUP_EMAIL',
  BLOCKED_PHONENUMBER = 'BLOCKED_PHONENUMBER',
  CODE_NOT_MATCH = 'CODE_NOT_MATCH',
  DELETED_EMAIL = 'DELETED_EMAIL',
  FAIL_JOIN_GROUP = 'FAIL_JOIN_GROUP',
  FORBIDDEN = 'FORBIDDEN',
  GROUP_PASSWORD_INVALID = 'GROUP_PASSWORD_INVALID',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_PASSWORD = 'INVALID_PASSWORD',
  INVALID_REQUEST = 'INVALID_REQUEST',
  NOT_FOUND = 'NOT_FOUND',
  NOT_FOUND_USER = 'NOT_FOUND_USER',
  SIGNUP_APPLICANT_NOT_FOUND = 'SIGNUP_APPLICANT_NOT_FOUND',
  SIGNUP_GROUP_NOT_FOUND = 'SIGNUP_GROUP_NOT_FOUND',
  STUDENT_ALREADY_EXIST = 'STUDENT_ALREADY_EXIST',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  UNDER_FOURTEEN_AGED = 'UNDER_FOURTEEN_AGED',
  UNKWON_ERROR = 'UNKWON_ERROR',
  WEEK_PASSWORD = 'WEEK_PASSWORD',
}

export type FindAccountsByPhoneInput = {
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type FindAccountsByPhonePayload = {
  __typename?: 'FindAccountsByPhonePayload';
  signupAccounts: Array<SignupAccount>;
};

export type GenerateApplicantWordbooksGroupPayload = {
  __typename?: 'GenerateApplicantWordbooksGroupPayload';
  result: Scalars['Boolean'];
};

export type Group = {
  __typename?: 'Group';
  created_at: Scalars['DateTime'];
  creator_id: Scalars['Int'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  organization_id: Scalars['Int'];
  secret_key: Scalars['String'];
  type: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** 온보딩 페이지에서 단어장 신청할떄 사용됩니다. */
  applyApplicant?: Maybe<ApplicantPayload>;
  applyWordbookUser?: Maybe<ApplyWordbookUserPayload>;
  findAccountsByPhone?: Maybe<FindAccountsByPhonePayload>;
  generateApplicantWordbooksGroup?: Maybe<GenerateApplicantWordbooksGroupPayload>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  sendApplicantVerifySMS?: Maybe<SendUserVerifySmsPayload>;
  /** 핸드폰 번호 인증 문자 보내기 */
  sendAuthVerifySMS?: Maybe<SendAuthVerifySmsPayload>;
  /**
   * Don't use. Use sendApplicantVerifySMS instead
   * @deprecated Use `sendApplicantVerifySMS`.
   */
  sendUserVerifySMS?: Maybe<SendUserVerifySmsPayload>;
  signinWithApplicant?: Maybe<SigninWithApplicantPayload>;
  signinWithEmail?: Maybe<SigninWithEmailPayload>;
  /**
   * Don't use. Use signupWithApplicant instead
   * @deprecated Use `signupWithApplicant`.
   */
  signup?: Maybe<SignupPayload>;
  signupWithApplicant?: Maybe<SignupPayload>;
  signupWithEmail?: Maybe<SignupWithEmailPayload>;
  signupWithEmailAndSchoolInfo?: Maybe<SignupWithEmailAndSchoolInfoPayload>;
  verifyApplicantCode?: Maybe<VerifyUserPayload>;
  /** 핸드폰 번호 인증 코드 확인하기 */
  verifyAuthCode?: Maybe<VerifyAuthCodePayload>;
  /**
   * Don't use. Use verifyApplicantCode instead
   * @deprecated Use `verifyApplicantCode`.
   */
  verifyUser?: Maybe<VerifyUserPayload>;
};

export type MutationApplyApplicantArgs = {
  input: ApplyApplicantInput;
};

export type MutationApplyWordbookUserArgs = {
  input: ApplyWordbookUserInput;
};

export type MutationFindAccountsByPhoneArgs = {
  input: FindAccountsByPhoneInput;
};

export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};

export type MutationSendApplicantVerifySmsArgs = {
  input: SendUserVerifySmsInput;
};

export type MutationSendAuthVerifySmsArgs = {
  input: SendAuthVerifySmsInput;
};

export type MutationSendUserVerifySmsArgs = {
  input: SendUserVerifySmsInput;
};

export type MutationSigninWithApplicantArgs = {
  input: SigninWithApplicantInput;
};

export type MutationSigninWithEmailArgs = {
  input: SigninWithEmailInput;
};

export type MutationSignupArgs = {
  input: SignupInput;
};

export type MutationSignupWithApplicantArgs = {
  input: SignupInput;
};

export type MutationSignupWithEmailArgs = {
  input: SignupWithEmailInput;
};

export type MutationSignupWithEmailAndSchoolInfoArgs = {
  input: SignupWithEmailAndSchoolInfoInput;
};

export type MutationVerifyApplicantCodeArgs = {
  input: VerifyUserInput;
};

export type MutationVerifyAuthCodeArgs = {
  input: VerifyAuthCodeInput;
};

export type MutationVerifyUserArgs = {
  input: VerifyUserInput;
};

export type Query = {
  __typename?: 'Query';
  applicantWordbook?: Maybe<ApplicantWordbook>;
  applicantWordbooks: Array<ApplicantWordbook>;
  viewer?: Maybe<User>;
};

export type QueryApplicantWordbookArgs = {
  input: ApplicantWordbookInput;
};

export type QueryApplicantWordbooksArgs = {
  filterPreset?: Maybe<ApplicantWordbooksFilterPreset>;
  types?: Maybe<Array<Scalars['Int']>>;
};

export type ResetPasswordInput = {
  code?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  newPassword: Scalars['String'];
  oldPassword?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  result: Scalars['Boolean'];
};

export type SchoolInfo = {
  code?: Maybe<Scalars['String']>;
  highSchoolType?: Maybe<Scalars['String']>;
  isAttending: Scalars['Boolean'];
  isRegistered: Scalars['Boolean'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type SendAuthVerifySmsInput = {
  authenticationType: AuthenticationType;
  email?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
};

export type SendAuthVerifySmsPayload = {
  __typename?: 'SendAuthVerifySMSPayload';
  result: Scalars['Boolean'];
};

export type SendUserVerifySmsInput = {
  applicantId: Scalars['ID'];
  phoneNumber: Scalars['String'];
};

export type SendUserVerifySmsPayload = {
  __typename?: 'SendUserVerifySMSPayload';
  checkResult: Scalars['Boolean'];
};

export type SigninWithApplicantInput = {
  applicantId: Scalars['ID'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type SigninWithApplicantPayload = {
  __typename?: 'SigninWithApplicantPayload';
  applicantWordbook: ApplicantWordbook;
  group: Group;
  token: Scalars['String'];
  user: User;
};

export type SigninWithEmailInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  type?: Maybe<SigninWithEmailType>;
};

export type SigninWithEmailPayload = {
  __typename?: 'SigninWithEmailPayload';
  token: Scalars['String'];
  user: User;
};

export enum SigninWithEmailType {
  ADMIN = 'ADMIN',
  CREATOR = 'CREATOR',
  DEVELOPER = 'DEVELOPER',
  MANAGER = 'MANAGER',
  STUDENT = 'STUDENT',
}

export type SignupAccount = {
  __typename?: 'SignupAccount';
  created_at: Scalars['DateTime'];
  deleted_at?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type SignupInput = {
  applicantId: Scalars['ID'];
  birth: Scalars['Date'];
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  region: Scalars['String'];
  schoolCode?: Maybe<Scalars['String']>;
  schoolHighSchoolType?: Maybe<Scalars['String']>;
  schoolIsAttending?: Maybe<Scalars['Boolean']>;
  schoolIsRegistered?: Maybe<Scalars['Boolean']>;
  schoolName?: Maybe<Scalars['String']>;
  schoolType?: Maybe<Scalars['String']>;
};

export type SignupPayload = {
  __typename?: 'SignupPayload';
  applicantWordbook: ApplicantWordbook;
  group: Group;
  user: User;
};

export type SignupWithEmailAndSchoolInfoInput = {
  birth: Scalars['Date'];
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
  region?: Maybe<Scalars['String']>;
  schoolInfo: SchoolInfo;
  verifyCode: Scalars['String'];
};

export type SignupWithEmailAndSchoolInfoPayload = {
  __typename?: 'SignupWithEmailAndSchoolInfoPayload';
  token: Scalars['String'];
  user?: Maybe<User>;
};

export type SignupWithEmailInput = {
  birth: Scalars['Date'];
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phoneNumber: Scalars['String'];
  region?: Maybe<Scalars['String']>;
  verifyCode: Scalars['String'];
};

export type SignupWithEmailPayload = {
  __typename?: 'SignupWithEmailPayload';
  token: Scalars['String'];
  user: User;
};

export type User = {
  __typename?: 'User';
  birth: Scalars['DateTime'];
  created_at: Scalars['DateTime'];
  email: Scalars['String'];
  hasPremium: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  nickname?: Maybe<Scalars['String']>;
  phone_number: Scalars['String'];
  profile_url: Scalars['String'];
  school_code?: Maybe<Scalars['String']>;
  school_high_school_type?: Maybe<Scalars['String']>;
  school_is_attending?: Maybe<Scalars['Boolean']>;
  school_is_registered?: Maybe<Scalars['Boolean']>;
  school_name?: Maybe<Scalars['String']>;
  school_type?: Maybe<Scalars['String']>;
};

export type VerifyAuthCodeInput = {
  code: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type VerifyAuthCodePayload = {
  __typename?: 'VerifyAuthCodePayload';
  result: Scalars['Boolean'];
};

export type VerifyUserInput = {
  applicantId: Scalars['ID'];
  code: Scalars['Int'];
};

export type VerifyUserPayload = {
  __typename?: 'VerifyUserPayload';
  applicantId: Scalars['ID'];
};

export type PersistingWhatsNewModalServiceProviderQueryVariables = Exact<{ [key: string]: never }>;

export type PersistingWhatsNewModalServiceProviderQuery = {
  __typename?: 'Query';
  viewer?: { __typename?: 'User'; id: string; created_at: any } | null | undefined;
};

export type ApplyApplicantMutationVariables = Exact<{
  input: ApplyApplicantInput;
}>;

export type ApplyApplicantMutation = {
  __typename?: 'Mutation';
  applyApplicant?:
    | { __typename?: 'ApplicantPayload'; applicant: { __typename?: 'Applicant'; id: string } }
    | null
    | undefined;
};

export type FindAccountsByPhoneMutationVariables = Exact<{
  input: FindAccountsByPhoneInput;
}>;

export type FindAccountsByPhoneMutation = {
  __typename?: 'Mutation';
  findAccountsByPhone?:
    | {
        __typename?: 'FindAccountsByPhonePayload';
        signupAccounts: Array<{
          __typename?: 'SignupAccount';
          email: string;
          deleted_at?: any | null | undefined;
          created_at: any;
        }>;
      }
    | null
    | undefined;
};

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;

export type ResetPasswordMutation = {
  __typename?: 'Mutation';
  resetPassword?: { __typename?: 'ResetPasswordPayload'; result: boolean } | null | undefined;
};

export type SendAuthVerifySmsMutationVariables = Exact<{
  input: SendAuthVerifySmsInput;
}>;

export type SendAuthVerifySmsMutation = {
  __typename?: 'Mutation';
  sendAuthVerifySMS?: { __typename?: 'SendAuthVerifySMSPayload'; result: boolean } | null | undefined;
};

export type SigninWithEmailMutationVariables = Exact<{
  input: SigninWithEmailInput;
}>;

export type SigninWithEmailMutation = {
  __typename?: 'Mutation';
  signinWithEmail?:
    | {
        __typename?: 'SigninWithEmailPayload';
        token: string;
        user: {
          __typename?: 'User';
          id: string;
          email: string;
          nickname?: string | null | undefined;
          hasPremium: boolean;
        };
      }
    | null
    | undefined;
};

export type SignupWithEmailMutationVariables = Exact<{
  input: SignupWithEmailInput;
}>;

export type SignupWithEmailMutation = {
  __typename?: 'Mutation';
  signupWithEmail?:
    | {
        __typename?: 'SignupWithEmailPayload';
        token: string;
        user: { __typename?: 'User'; id: string; email: string; nickname?: string | null | undefined };
      }
    | null
    | undefined;
};

export type SignupWithEmailAndSchoolInfoMutationVariables = Exact<{
  input: SignupWithEmailAndSchoolInfoInput;
}>;

export type SignupWithEmailAndSchoolInfoMutation = {
  __typename?: 'Mutation';
  signupWithEmailAndSchoolInfo?:
    | {
        __typename?: 'SignupWithEmailAndSchoolInfoPayload';
        token: string;
        user?:
          | { __typename?: 'User'; id: string; email: string; nickname?: string | null | undefined }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type VerifyAuthCodeMutationVariables = Exact<{
  input: VerifyAuthCodeInput;
}>;

export type VerifyAuthCodeMutation = {
  __typename?: 'Mutation';
  verifyAuthCode?: { __typename?: 'VerifyAuthCodePayload'; result: boolean } | null | undefined;
};

export type OnboardingConsentGroupStudyQueryVariables = Exact<{ [key: string]: never }>;

export type OnboardingConsentGroupStudyQuery = {
  __typename?: 'Query';
  viewer?: { __typename?: 'User'; id: string; name: string } | null | undefined;
};

export type OnboardingLearningMethodQueryVariables = Exact<{ [key: string]: never }>;

export type OnboardingLearningMethodQuery = {
  __typename?: 'Query';
  viewer?: { __typename?: 'User'; id: string; name: string; hasPremium: boolean } | null | undefined;
};

export type OnboardingPremiumInfoQueryVariables = Exact<{ [key: string]: never }>;

export type OnboardingPremiumInfoQuery = {
  __typename?: 'Query';
  viewer?: { __typename?: 'User'; id: string; name: string } | null | undefined;
};

export type OnboardingRejectGroupStudyQueryVariables = Exact<{ [key: string]: never }>;

export type OnboardingRejectGroupStudyQuery = {
  __typename?: 'Query';
  viewer?: { __typename?: 'User'; id: string; name: string } | null | undefined;
};

export type OnboardingSelectWordbookStepQueryVariables = Exact<{ [key: string]: never }>;

export type OnboardingSelectWordbookStepQuery = {
  __typename?: 'Query';
  applicantWordbooks: Array<{
    __typename?: 'ApplicantWordbook';
    id: string;
    title: string;
    subtitle: string;
    type?: number | null | undefined;
    description: string;
    detail: string;
    total_word_amount: number;
    daily_word_amount: number;
    color: string;
  }>;
};

export type OnboardingSelectWordbookStep_ApplicantWordbookFragment = {
  __typename?: 'ApplicantWordbook';
  id: string;
  title: string;
  subtitle: string;
  type?: number | null | undefined;
  description: string;
  detail: string;
  total_word_amount: number;
  daily_word_amount: number;
  color: string;
};

export type OnboardingWaitingPremiumQueryVariables = Exact<{ [key: string]: never }>;

export type OnboardingWaitingPremiumQuery = {
  __typename?: 'Query';
  viewer?: { __typename?: 'User'; id: string; name: string; hasPremium: boolean } | null | undefined;
};

export type OnboardingWordbookDetailStepQueryVariables = Exact<{
  input: ApplicantWordbookInput;
}>;

export type OnboardingWordbookDetailStepQuery = {
  __typename?: 'Query';
  applicantWordbook?:
    | {
        __typename?: 'ApplicantWordbook';
        id: string;
        title: string;
        description: string;
        total_word_amount: number;
        daily_word_amount: number;
        dDate?: any | null | undefined;
        sunday: boolean;
        monday: boolean;
        tuseday: boolean;
        wednesday: boolean;
        thursday: boolean;
        friday: boolean;
        saturday: boolean;
      }
    | null
    | undefined;
};

export type OnboardingWordbookDetailStep_GetWordBookWeekDays_ApplicantWordbookFragment = {
  __typename?: 'ApplicantWordbook';
  id: string;
  sunday: boolean;
  monday: boolean;
  tuseday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  daily_word_amount: number;
};

export type Datadog_SetUser_UserFragment = {
  __typename?: 'User';
  id: string;
  email: string;
  nickname?: string | null | undefined;
};

export const OnboardingSelectWordbookStep_ApplicantWordbookFragmentDoc = gql`
  fragment OnboardingSelectWordbookStep_ApplicantWordbook on ApplicantWordbook {
    id
    title
    subtitle
    type
    description
    detail
    total_word_amount
    daily_word_amount
    color
  }
`;
export const OnboardingWordbookDetailStep_GetWordBookWeekDays_ApplicantWordbookFragmentDoc = gql`
  fragment OnboardingWordbookDetailStep_GetWordBookWeekDays_ApplicantWordbook on ApplicantWordbook {
    id
    sunday
    monday
    tuseday
    wednesday
    thursday
    friday
    saturday
    daily_word_amount
  }
`;
export const Datadog_SetUser_UserFragmentDoc = gql`
  fragment Datadog_SetUser_User on User {
    id
    email
    nickname
  }
`;
export const PersistingWhatsNewModalServiceProviderDocument = gql`
  query PersistingWhatsNewModalServiceProvider {
    viewer {
      id
      created_at
    }
  }
`;

/**
 * __usePersistingWhatsNewModalServiceProviderQuery__
 *
 * To run a query within a React component, call `usePersistingWhatsNewModalServiceProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersistingWhatsNewModalServiceProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersistingWhatsNewModalServiceProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersistingWhatsNewModalServiceProviderQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PersistingWhatsNewModalServiceProviderQuery,
    PersistingWhatsNewModalServiceProviderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PersistingWhatsNewModalServiceProviderQuery,
    PersistingWhatsNewModalServiceProviderQueryVariables
  >(PersistingWhatsNewModalServiceProviderDocument, options);
}
export function usePersistingWhatsNewModalServiceProviderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PersistingWhatsNewModalServiceProviderQuery,
    PersistingWhatsNewModalServiceProviderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PersistingWhatsNewModalServiceProviderQuery,
    PersistingWhatsNewModalServiceProviderQueryVariables
  >(PersistingWhatsNewModalServiceProviderDocument, options);
}
export type PersistingWhatsNewModalServiceProviderQueryHookResult = ReturnType<
  typeof usePersistingWhatsNewModalServiceProviderQuery
>;
export type PersistingWhatsNewModalServiceProviderLazyQueryHookResult = ReturnType<
  typeof usePersistingWhatsNewModalServiceProviderLazyQuery
>;
export type PersistingWhatsNewModalServiceProviderQueryResult = Apollo.QueryResult<
  PersistingWhatsNewModalServiceProviderQuery,
  PersistingWhatsNewModalServiceProviderQueryVariables
>;
export const ApplyApplicantDocument = gql`
  mutation ApplyApplicant($input: ApplyApplicantInput!) {
    applyApplicant(input: $input) {
      applicant {
        id
      }
    }
  }
`;
export type ApplyApplicantMutationFn = Apollo.MutationFunction<
  ApplyApplicantMutation,
  ApplyApplicantMutationVariables
>;

/**
 * __useApplyApplicantMutation__
 *
 * To run a mutation, you first call `useApplyApplicantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyApplicantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyApplicantMutation, { data, loading, error }] = useApplyApplicantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyApplicantMutation(
  baseOptions?: Apollo.MutationHookOptions<ApplyApplicantMutation, ApplyApplicantMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ApplyApplicantMutation, ApplyApplicantMutationVariables>(
    ApplyApplicantDocument,
    options,
  );
}
export type ApplyApplicantMutationHookResult = ReturnType<typeof useApplyApplicantMutation>;
export type ApplyApplicantMutationResult = Apollo.MutationResult<ApplyApplicantMutation>;
export type ApplyApplicantMutationOptions = Apollo.BaseMutationOptions<
  ApplyApplicantMutation,
  ApplyApplicantMutationVariables
>;
export const FindAccountsByPhoneDocument = gql`
  mutation FindAccountsByPhone($input: FindAccountsByPhoneInput!) {
    findAccountsByPhone(input: $input) {
      signupAccounts {
        email
        deleted_at
        created_at
      }
    }
  }
`;
export type FindAccountsByPhoneMutationFn = Apollo.MutationFunction<
  FindAccountsByPhoneMutation,
  FindAccountsByPhoneMutationVariables
>;

/**
 * __useFindAccountsByPhoneMutation__
 *
 * To run a mutation, you first call `useFindAccountsByPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindAccountsByPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findAccountsByPhoneMutation, { data, loading, error }] = useFindAccountsByPhoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindAccountsByPhoneMutation(
  baseOptions?: Apollo.MutationHookOptions<FindAccountsByPhoneMutation, FindAccountsByPhoneMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FindAccountsByPhoneMutation, FindAccountsByPhoneMutationVariables>(
    FindAccountsByPhoneDocument,
    options,
  );
}
export type FindAccountsByPhoneMutationHookResult = ReturnType<typeof useFindAccountsByPhoneMutation>;
export type FindAccountsByPhoneMutationResult = Apollo.MutationResult<FindAccountsByPhoneMutation>;
export type FindAccountsByPhoneMutationOptions = Apollo.BaseMutationOptions<
  FindAccountsByPhoneMutation,
  FindAccountsByPhoneMutationVariables
>;
export const ResetPasswordDocument = gql`
  mutation ResetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      result
    }
  }
`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(
    ResetPasswordDocument,
    options,
  );
}
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const SendAuthVerifySmsDocument = gql`
  mutation SendAuthVerifySMS($input: SendAuthVerifySMSInput!) {
    sendAuthVerifySMS(input: $input) {
      result
    }
  }
`;
export type SendAuthVerifySmsMutationFn = Apollo.MutationFunction<
  SendAuthVerifySmsMutation,
  SendAuthVerifySmsMutationVariables
>;

/**
 * __useSendAuthVerifySmsMutation__
 *
 * To run a mutation, you first call `useSendAuthVerifySmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAuthVerifySmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAuthVerifySmsMutation, { data, loading, error }] = useSendAuthVerifySmsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAuthVerifySmsMutation(
  baseOptions?: Apollo.MutationHookOptions<SendAuthVerifySmsMutation, SendAuthVerifySmsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendAuthVerifySmsMutation, SendAuthVerifySmsMutationVariables>(
    SendAuthVerifySmsDocument,
    options,
  );
}
export type SendAuthVerifySmsMutationHookResult = ReturnType<typeof useSendAuthVerifySmsMutation>;
export type SendAuthVerifySmsMutationResult = Apollo.MutationResult<SendAuthVerifySmsMutation>;
export type SendAuthVerifySmsMutationOptions = Apollo.BaseMutationOptions<
  SendAuthVerifySmsMutation,
  SendAuthVerifySmsMutationVariables
>;
export const SigninWithEmailDocument = gql`
  mutation SigninWithEmail($input: SigninWithEmailInput!) {
    signinWithEmail(input: $input) {
      user {
        id
        email
        nickname
        hasPremium
        ...Datadog_SetUser_User @unmask(mode: "migrate")
      }
      token
    }
  }
  ${Datadog_SetUser_UserFragmentDoc}
`;
export type SigninWithEmailMutationFn = Apollo.MutationFunction<
  SigninWithEmailMutation,
  SigninWithEmailMutationVariables
>;

/**
 * __useSigninWithEmailMutation__
 *
 * To run a mutation, you first call `useSigninWithEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSigninWithEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signinWithEmailMutation, { data, loading, error }] = useSigninWithEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSigninWithEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<SigninWithEmailMutation, SigninWithEmailMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SigninWithEmailMutation, SigninWithEmailMutationVariables>(
    SigninWithEmailDocument,
    options,
  );
}
export type SigninWithEmailMutationHookResult = ReturnType<typeof useSigninWithEmailMutation>;
export type SigninWithEmailMutationResult = Apollo.MutationResult<SigninWithEmailMutation>;
export type SigninWithEmailMutationOptions = Apollo.BaseMutationOptions<
  SigninWithEmailMutation,
  SigninWithEmailMutationVariables
>;
export const SignupWithEmailDocument = gql`
  mutation SignupWithEmail($input: SignupWithEmailInput!) {
    signupWithEmail(input: $input) {
      user {
        id
        email
        nickname
        ...Datadog_SetUser_User @unmask(mode: "migrate")
      }
      token
    }
  }
  ${Datadog_SetUser_UserFragmentDoc}
`;
export type SignupWithEmailMutationFn = Apollo.MutationFunction<
  SignupWithEmailMutation,
  SignupWithEmailMutationVariables
>;

/**
 * __useSignupWithEmailMutation__
 *
 * To run a mutation, you first call `useSignupWithEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupWithEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupWithEmailMutation, { data, loading, error }] = useSignupWithEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupWithEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<SignupWithEmailMutation, SignupWithEmailMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SignupWithEmailMutation, SignupWithEmailMutationVariables>(
    SignupWithEmailDocument,
    options,
  );
}
export type SignupWithEmailMutationHookResult = ReturnType<typeof useSignupWithEmailMutation>;
export type SignupWithEmailMutationResult = Apollo.MutationResult<SignupWithEmailMutation>;
export type SignupWithEmailMutationOptions = Apollo.BaseMutationOptions<
  SignupWithEmailMutation,
  SignupWithEmailMutationVariables
>;
export const SignupWithEmailAndSchoolInfoDocument = gql`
  mutation SignupWithEmailAndSchoolInfo($input: SignupWithEmailAndSchoolInfoInput!) {
    signupWithEmailAndSchoolInfo(input: $input) {
      user {
        id
        email
        nickname
        ...Datadog_SetUser_User @unmask(mode: "migrate")
      }
      token
    }
  }
  ${Datadog_SetUser_UserFragmentDoc}
`;
export type SignupWithEmailAndSchoolInfoMutationFn = Apollo.MutationFunction<
  SignupWithEmailAndSchoolInfoMutation,
  SignupWithEmailAndSchoolInfoMutationVariables
>;

/**
 * __useSignupWithEmailAndSchoolInfoMutation__
 *
 * To run a mutation, you first call `useSignupWithEmailAndSchoolInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupWithEmailAndSchoolInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupWithEmailAndSchoolInfoMutation, { data, loading, error }] = useSignupWithEmailAndSchoolInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupWithEmailAndSchoolInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignupWithEmailAndSchoolInfoMutation,
    SignupWithEmailAndSchoolInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SignupWithEmailAndSchoolInfoMutation,
    SignupWithEmailAndSchoolInfoMutationVariables
  >(SignupWithEmailAndSchoolInfoDocument, options);
}
export type SignupWithEmailAndSchoolInfoMutationHookResult = ReturnType<
  typeof useSignupWithEmailAndSchoolInfoMutation
>;
export type SignupWithEmailAndSchoolInfoMutationResult =
  Apollo.MutationResult<SignupWithEmailAndSchoolInfoMutation>;
export type SignupWithEmailAndSchoolInfoMutationOptions = Apollo.BaseMutationOptions<
  SignupWithEmailAndSchoolInfoMutation,
  SignupWithEmailAndSchoolInfoMutationVariables
>;
export const VerifyAuthCodeDocument = gql`
  mutation VerifyAuthCode($input: VerifyAuthCodeInput!) {
    verifyAuthCode(input: $input) {
      result
    }
  }
`;
export type VerifyAuthCodeMutationFn = Apollo.MutationFunction<
  VerifyAuthCodeMutation,
  VerifyAuthCodeMutationVariables
>;

/**
 * __useVerifyAuthCodeMutation__
 *
 * To run a mutation, you first call `useVerifyAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAuthCodeMutation, { data, loading, error }] = useVerifyAuthCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyAuthCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyAuthCodeMutation, VerifyAuthCodeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyAuthCodeMutation, VerifyAuthCodeMutationVariables>(
    VerifyAuthCodeDocument,
    options,
  );
}
export type VerifyAuthCodeMutationHookResult = ReturnType<typeof useVerifyAuthCodeMutation>;
export type VerifyAuthCodeMutationResult = Apollo.MutationResult<VerifyAuthCodeMutation>;
export type VerifyAuthCodeMutationOptions = Apollo.BaseMutationOptions<
  VerifyAuthCodeMutation,
  VerifyAuthCodeMutationVariables
>;
export const OnboardingConsentGroupStudyDocument = gql`
  query OnboardingConsentGroupStudy {
    viewer {
      id
      name
    }
  }
`;

/**
 * __useOnboardingConsentGroupStudyQuery__
 *
 * To run a query within a React component, call `useOnboardingConsentGroupStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingConsentGroupStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingConsentGroupStudyQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingConsentGroupStudyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OnboardingConsentGroupStudyQuery,
    OnboardingConsentGroupStudyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OnboardingConsentGroupStudyQuery, OnboardingConsentGroupStudyQueryVariables>(
    OnboardingConsentGroupStudyDocument,
    options,
  );
}
export function useOnboardingConsentGroupStudyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OnboardingConsentGroupStudyQuery,
    OnboardingConsentGroupStudyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OnboardingConsentGroupStudyQuery, OnboardingConsentGroupStudyQueryVariables>(
    OnboardingConsentGroupStudyDocument,
    options,
  );
}
export type OnboardingConsentGroupStudyQueryHookResult = ReturnType<
  typeof useOnboardingConsentGroupStudyQuery
>;
export type OnboardingConsentGroupStudyLazyQueryHookResult = ReturnType<
  typeof useOnboardingConsentGroupStudyLazyQuery
>;
export type OnboardingConsentGroupStudyQueryResult = Apollo.QueryResult<
  OnboardingConsentGroupStudyQuery,
  OnboardingConsentGroupStudyQueryVariables
>;
export const OnboardingLearningMethodDocument = gql`
  query OnboardingLearningMethod {
    viewer {
      id
      name
      hasPremium
    }
  }
`;

/**
 * __useOnboardingLearningMethodQuery__
 *
 * To run a query within a React component, call `useOnboardingLearningMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingLearningMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingLearningMethodQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingLearningMethodQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OnboardingLearningMethodQuery,
    OnboardingLearningMethodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OnboardingLearningMethodQuery, OnboardingLearningMethodQueryVariables>(
    OnboardingLearningMethodDocument,
    options,
  );
}
export function useOnboardingLearningMethodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OnboardingLearningMethodQuery,
    OnboardingLearningMethodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OnboardingLearningMethodQuery, OnboardingLearningMethodQueryVariables>(
    OnboardingLearningMethodDocument,
    options,
  );
}
export type OnboardingLearningMethodQueryHookResult = ReturnType<typeof useOnboardingLearningMethodQuery>;
export type OnboardingLearningMethodLazyQueryHookResult = ReturnType<
  typeof useOnboardingLearningMethodLazyQuery
>;
export type OnboardingLearningMethodQueryResult = Apollo.QueryResult<
  OnboardingLearningMethodQuery,
  OnboardingLearningMethodQueryVariables
>;
export const OnboardingPremiumInfoDocument = gql`
  query OnboardingPremiumInfo {
    viewer {
      id
      name
    }
  }
`;

/**
 * __useOnboardingPremiumInfoQuery__
 *
 * To run a query within a React component, call `useOnboardingPremiumInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingPremiumInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingPremiumInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingPremiumInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<OnboardingPremiumInfoQuery, OnboardingPremiumInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OnboardingPremiumInfoQuery, OnboardingPremiumInfoQueryVariables>(
    OnboardingPremiumInfoDocument,
    options,
  );
}
export function useOnboardingPremiumInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OnboardingPremiumInfoQuery, OnboardingPremiumInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OnboardingPremiumInfoQuery, OnboardingPremiumInfoQueryVariables>(
    OnboardingPremiumInfoDocument,
    options,
  );
}
export type OnboardingPremiumInfoQueryHookResult = ReturnType<typeof useOnboardingPremiumInfoQuery>;
export type OnboardingPremiumInfoLazyQueryHookResult = ReturnType<typeof useOnboardingPremiumInfoLazyQuery>;
export type OnboardingPremiumInfoQueryResult = Apollo.QueryResult<
  OnboardingPremiumInfoQuery,
  OnboardingPremiumInfoQueryVariables
>;
export const OnboardingRejectGroupStudyDocument = gql`
  query OnboardingRejectGroupStudy {
    viewer {
      id
      name
    }
  }
`;

/**
 * __useOnboardingRejectGroupStudyQuery__
 *
 * To run a query within a React component, call `useOnboardingRejectGroupStudyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingRejectGroupStudyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingRejectGroupStudyQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingRejectGroupStudyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OnboardingRejectGroupStudyQuery,
    OnboardingRejectGroupStudyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OnboardingRejectGroupStudyQuery, OnboardingRejectGroupStudyQueryVariables>(
    OnboardingRejectGroupStudyDocument,
    options,
  );
}
export function useOnboardingRejectGroupStudyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OnboardingRejectGroupStudyQuery,
    OnboardingRejectGroupStudyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OnboardingRejectGroupStudyQuery, OnboardingRejectGroupStudyQueryVariables>(
    OnboardingRejectGroupStudyDocument,
    options,
  );
}
export type OnboardingRejectGroupStudyQueryHookResult = ReturnType<typeof useOnboardingRejectGroupStudyQuery>;
export type OnboardingRejectGroupStudyLazyQueryHookResult = ReturnType<
  typeof useOnboardingRejectGroupStudyLazyQuery
>;
export type OnboardingRejectGroupStudyQueryResult = Apollo.QueryResult<
  OnboardingRejectGroupStudyQuery,
  OnboardingRejectGroupStudyQueryVariables
>;
export const OnboardingSelectWordbookStepDocument = gql`
  query OnboardingSelectWordbookStep {
    applicantWordbooks(filterPreset: ONBOARDING_SIGNUP) {
      ...OnboardingSelectWordbookStep_ApplicantWordbook @unmask(mode: "migrate")
    }
  }
  ${OnboardingSelectWordbookStep_ApplicantWordbookFragmentDoc}
`;

/**
 * __useOnboardingSelectWordbookStepQuery__
 *
 * To run a query within a React component, call `useOnboardingSelectWordbookStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingSelectWordbookStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingSelectWordbookStepQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingSelectWordbookStepQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OnboardingSelectWordbookStepQuery,
    OnboardingSelectWordbookStepQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OnboardingSelectWordbookStepQuery, OnboardingSelectWordbookStepQueryVariables>(
    OnboardingSelectWordbookStepDocument,
    options,
  );
}
export function useOnboardingSelectWordbookStepLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OnboardingSelectWordbookStepQuery,
    OnboardingSelectWordbookStepQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OnboardingSelectWordbookStepQuery, OnboardingSelectWordbookStepQueryVariables>(
    OnboardingSelectWordbookStepDocument,
    options,
  );
}
export type OnboardingSelectWordbookStepQueryHookResult = ReturnType<
  typeof useOnboardingSelectWordbookStepQuery
>;
export type OnboardingSelectWordbookStepLazyQueryHookResult = ReturnType<
  typeof useOnboardingSelectWordbookStepLazyQuery
>;
export type OnboardingSelectWordbookStepQueryResult = Apollo.QueryResult<
  OnboardingSelectWordbookStepQuery,
  OnboardingSelectWordbookStepQueryVariables
>;
export const OnboardingWaitingPremiumDocument = gql`
  query OnboardingWaitingPremium {
    viewer {
      id
      name
      hasPremium
    }
  }
`;

/**
 * __useOnboardingWaitingPremiumQuery__
 *
 * To run a query within a React component, call `useOnboardingWaitingPremiumQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingWaitingPremiumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingWaitingPremiumQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingWaitingPremiumQuery(
  baseOptions?: Apollo.QueryHookOptions<
    OnboardingWaitingPremiumQuery,
    OnboardingWaitingPremiumQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OnboardingWaitingPremiumQuery, OnboardingWaitingPremiumQueryVariables>(
    OnboardingWaitingPremiumDocument,
    options,
  );
}
export function useOnboardingWaitingPremiumLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OnboardingWaitingPremiumQuery,
    OnboardingWaitingPremiumQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OnboardingWaitingPremiumQuery, OnboardingWaitingPremiumQueryVariables>(
    OnboardingWaitingPremiumDocument,
    options,
  );
}
export type OnboardingWaitingPremiumQueryHookResult = ReturnType<typeof useOnboardingWaitingPremiumQuery>;
export type OnboardingWaitingPremiumLazyQueryHookResult = ReturnType<
  typeof useOnboardingWaitingPremiumLazyQuery
>;
export type OnboardingWaitingPremiumQueryResult = Apollo.QueryResult<
  OnboardingWaitingPremiumQuery,
  OnboardingWaitingPremiumQueryVariables
>;
export const OnboardingWordbookDetailStepDocument = gql`
  query OnboardingWordbookDetailStep($input: ApplicantWordbookInput!) {
    applicantWordbook(input: $input) {
      ...OnboardingWordbookDetailStep_GetWordBookWeekDays_ApplicantWordbook @unmask(mode: "migrate")
      id
      title
      description
      total_word_amount
      daily_word_amount
      dDate
    }
  }
  ${OnboardingWordbookDetailStep_GetWordBookWeekDays_ApplicantWordbookFragmentDoc}
`;

/**
 * __useOnboardingWordbookDetailStepQuery__
 *
 * To run a query within a React component, call `useOnboardingWordbookDetailStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingWordbookDetailStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingWordbookDetailStepQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingWordbookDetailStepQuery(
  baseOptions: Apollo.QueryHookOptions<
    OnboardingWordbookDetailStepQuery,
    OnboardingWordbookDetailStepQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OnboardingWordbookDetailStepQuery, OnboardingWordbookDetailStepQueryVariables>(
    OnboardingWordbookDetailStepDocument,
    options,
  );
}
export function useOnboardingWordbookDetailStepLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OnboardingWordbookDetailStepQuery,
    OnboardingWordbookDetailStepQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OnboardingWordbookDetailStepQuery, OnboardingWordbookDetailStepQueryVariables>(
    OnboardingWordbookDetailStepDocument,
    options,
  );
}
export type OnboardingWordbookDetailStepQueryHookResult = ReturnType<
  typeof useOnboardingWordbookDetailStepQuery
>;
export type OnboardingWordbookDetailStepLazyQueryHookResult = ReturnType<
  typeof useOnboardingWordbookDetailStepLazyQuery
>;
export type OnboardingWordbookDetailStepQueryResult = Apollo.QueryResult<
  OnboardingWordbookDetailStepQuery,
  OnboardingWordbookDetailStepQueryVariables
>;
